namespace TabAurous.Scheme {

    @Serenity.Decorators.registerEditor()
    export class SchemePaymentModesEditor extends Serenity.Select2Editor<any, any> {

        constructor(container: JQuery) {
            super(container, null);

            this.addOption("Cash", "Cash");
            this.addOption("Cheque", "Cheque");
            this.addOption("Credit Card", "Credit Card");
            this.addOption("Debit Card", "Debit Card");
            this.addOption("NEFT", "NEFT");
            this.addOption("UPI", "UPI");


        }
    }
}